import contentful from "libraries/contentful/client";
import ContentfulRichText from "./ContentfulRichText";
import ContentfulEntry from "models/data/contentful/ContentfulEntry";
import { get } from "lodash";

class ContentfulCategory {
  static default = {
    name: "",
    slug: "",
    description: "",
    longDescription: "",
    title: "",
    metaDescription: ""
  };

  static id = (contentfulCategory) => ContentfulEntry.id(contentfulCategory);

  static slug = (contentfulCategory) => {
    const fields = ContentfulEntry.fields(contentfulCategory);
    const slug = get(fields, "slug", ContentfulCategory.default.slug);
    return slug;
  };

  static categoryName = (contentfulCategory) => {
    const fields = ContentfulEntry.fields(contentfulCategory);
    const name = get(fields, "categoryName", ContentfulCategory.default.name);
    return name;
  };

  static descriptionHtml = (contentfulCategory) => {
    const fields = ContentfulEntry.fields(contentfulCategory);
    const description = get(
      fields,
      "description",
      ContentfulCategory.default.description
    );
    const descriptionHtml = ContentfulRichText.toHtml(description);
    return descriptionHtml;
  };

  static longDescriptionHtml = (contentfulCategory) => {
    const fields = ContentfulEntry.fields(contentfulCategory);
    const longDescription = get(
      fields,
      "longDescription",
      ContentfulCategory.default.longDescription
    );
    const longDescriptionHtml = ContentfulRichText.toHtml(longDescription);
    return longDescriptionHtml;
  };

  static title = (contentfulCategory) => {
    const fields = ContentfulEntry.fields(contentfulCategory);
    const title = get(fields, "title", ContentfulCategory.default.title);
    return title;
  }

   static metaDescription = (contentfulCategory) => {
    const fields = ContentfulEntry.fields(contentfulCategory);
    const metaDescription = get(fields, "metaDescription", ContentfulCategory.default.metaDescription);
    return metaDescription;
  }

  static async fetchWithId(categoryId) {
    const entries = await contentful.getEntries({
      content_type: "category",
      "sys.id": categoryId,
    });
    const [contentfulCategory] = [...get(entries, "items", [])];
    return contentfulCategory;
  }

  static async fetchWithSlug(categorySlug) {
    const entries = await contentful.getEntries({
      content_type: "category",
      "fields.slug": categorySlug,
    });
    const [contentfulCategory] = [...get(entries, "items", [])];
    return contentfulCategory;
  }
}

export default ContentfulCategory;
